import { Button } from '@library/components/buttons';
import removeIcon from '@library/assets/images/icons/white-trash-icon.svg';

export interface RemoveRowButtonProps {
  className?: string;
  disabled?: boolean;
  imageAltText?: string;
  onClick: () => void;
}

export const RemoveRowButton = ({
  className = '',
  disabled = false,
  imageAltText = 'Remove',
  onClick
}: RemoveRowButtonProps) => {
  return (
    <Button className={className} disabled={disabled} onClick={onClick}>
      <img src={removeIcon} alt={imageAltText} />
    </Button>
  );
};
